import React, { useEffect, useState, useRef, useMemo, Fragment } from "react";
import { useCursorPopup, useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserStruct } from "api";
import { Utils } from "helpers/utils";
import { TaskStatus, WpEmpFilterType, WpSliceData } from "../../../redux/workplace/wpTypes";
import UserAvatarWithName from "components/UserAvatarWithName";
import classnames from "classnames";
import AppSimpleBar from "components/AppSimpleBar";
import { loadPostTitle, loadTaskDash, loadTaskDashStatusRange, loadTaskDashTags, setTaskDashFilterTagId } from "../../../redux/workplace/wpActions";
import { WpModes } from "../../../constants";
import HelpInfo from "components/HelpInfo";
import DatePickerEx from "components/DatePickerEx";
import { ElementWidthObserver } from "components/ElementWidthObserver";
import Loader from "components/Loader";
import LoadingIconWithText from "components/LoadingIconWithText";
import { StorageUtils } from "helpers/storageutils";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import SelectDropdown from "components/SelectDropdown";


const LineDash: React.FC = ({ }) => {
  return (
    <div className="mt-2 mb-2" style={{ borderTop: "dashed 1px var(--m2-line-divider-color)" }}></div>
  );

}

const taskStatuses = [TaskStatus.ToDo, TaskStatus.OnGoing, TaskStatus.Hold, TaskStatus.Cancel, TaskStatus.Finished];

let lastTaskCount = 0;
const fnGetTaskCount = (taskSummary: any, filterTagId: number | null) => {
  if (filterTagId == null) {
    const total = (taskSummary?.status_ToDo ?? 0) + (taskSummary?.status_Finished ?? 0) + (taskSummary?.status_Cancel ?? 0) + (taskSummary?.status_OnGoing ?? 0) + (taskSummary?.status_Hold ?? 0);
    lastTaskCount = total;
  }
  return lastTaskCount;
}


interface StatusSummaryProps {
  title: "MINE" | "ALL";
  data: any;
  onReloadTaskTitle(taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: number | null, requesterId: number | null): void;
  curUserId: number;
  curUserTagId: number;
  filterTagId: number | null;
}

const StatusSummary: React.FC<StatusSummaryProps> = ({ title, data, onReloadTaskTitle, curUserId, curUserTagId, filterTagId }) => {
  const total = fnGetTaskCount(data, filterTagId);
  if (total <= 0 && title === "MINE") return (<></>);
  return (
    <div className="tkd-status-summary-card wp-conver-content" style={{ height: "100%" }}>
      <h4 className="">{title === "MINE" ? "งานของฉัน" : "งานทั้งหมด"}</h4>
      <LineDash />
      <div className="tkd-status-grid">
        {taskStatuses.map((item: TaskStatus, index) => {
          const statusName = TaskStatus[item];
          const propName = "status_" + statusName.replaceAll(" ", "");
          const icon = Utils.GetTaskStatusIcon(item);
          const css = "badge-task-status-" + statusName.toLowerCase();
          const responder = (title == "MINE" ? curUserId : null) ?? null;
          const responderTagId = (title == "MINE" ? [] : null) ?? null;
          const statusText = Utils.GetTaskStatusText(item);
          // console.log(propName);
          return (
            <div
              key={index} className={"d-flex justify-content-between hover hand " + css}
              onClick={(e) => onReloadTaskTitle(item, responder?.toString(), responderTagId, null, null)}
            >
              <div>{icon}{statusText} </div>
              <div>{data ? data[propName] : 0}</div>
            </div>
          )
        })}
        {/* <div className="d-flex justify-content-between"><div>To Do </div><div>{data["status_ToDo"]}</div></div>
          <div className="d-flex justify-content-between"><div>On Going </div><div>{data.status_OnGoing}</div></div>
          <div className="d-flex justify-content-between"><div>Finished </div><div>{data.status_Finished}</div></div>
          <div className="d-flex justify-content-between"><div>Hold </div><div>{data.status_Hold}</div></div>
          <div className="d-flex justify-content-between"><div>Cancel </div><div>{data.status_Cancel}</div></div> */}
      </div>
    </div>
  );
};
interface RangeStatusStatProps {
  onDateChange(date1: Date | null, date2: Date | null): void;
  taskStatusRange: any;
  taskDashStatusLoading: boolean;
  onFilterTaskTitle(mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "OVERDUE"): void;
}
const RangeStatusStat: React.FC<RangeStatusStatProps> = ({ onDateChange, taskStatusRange, taskDashStatusLoading, onFilterTaskTitle }) => {
  const [showCustomDate, setShowCustomDate] = useState<boolean>(false);

  const [date1, setDate1] = useState<Date | null>(null);
  const [date2, setDate2] = useState<Date | null>(null);

  const today = new Date();
  const prevWeek = new Date(new Date(today).setDate(today.getDate() - 7));
  const prevMonth = new Date(new Date(today).setMonth(today.getMonth() - 1));

  const dates = {
    thisWeek1: Utils.GetFirstDateOfWeek(today),
    thisWeek2: Utils.GetLastDateOfWeek(today),
    prevWeek1: Utils.GetFirstDateOfWeek(prevWeek),
    prevWeek2: Utils.GetLastDateOfWeek(prevWeek),
    thisMonth1: Utils.GetFirstDateOfMonth(today),
    thisMonth2: Utils.GetLastDateOfMonth(today),
    prevMonth1: Utils.GetFirstDateOfMonth(prevMonth),
    prevMonth2: Utils.GetLastDateOfMonth(prevMonth),
  }

  const isSameDay = (a: Date | null, b: Date) => a?.getFullYear() === b.getFullYear() && a?.getMonth() === b.getMonth() && a?.getDate() === b.getDate();

  const isThisWeek = isSameDay(date1, dates.thisWeek1) && isSameDay(date2, dates.thisWeek2);
  const isPrevWeek = isSameDay(date1, dates.prevWeek1) && isSameDay(date2, dates.prevWeek2);
  const isThisMonth = isSameDay(date1, dates.thisMonth1) && isSameDay(date2, dates.thisMonth2);
  const isPrevMonth = isSameDay(date1, dates.prevMonth1) && isSameDay(date2, dates.prevMonth2);

  const onClickHeader = (e: React.MouseEvent) => {
    openAtCursor(e);
    setShowCustomDate(prev => !prev);
  }
  useEffect(() => {
    if (showCustomDate) {
      if (date1 == null || date2 == null) {
        setDate1(Utils.GetFirstDateOfWeek(today));
        setDate2(Utils.GetLastDateOfWeek(today));
      }
    }
  }, [showCustomDate]);
  const setDateRange = (range: "THIS_WEEK" | "PREV_WEEK" | "THIS_MONTH" | "PREV_MONTH") => {
    let dt1 = new Date();
    let dt2 = new Date();
    switch (range) {
      case "THIS_WEEK": dt1 = dates.thisWeek1; dt2 = dates.thisWeek2; break;
      case "PREV_WEEK": dt1 = dates.prevWeek1; dt2 = dates.prevWeek2; break;
      case "THIS_MONTH": dt1 = dates.thisMonth1; dt2 = dates.thisMonth2; break;
      case "PREV_MONTH": dt1 = dates.prevMonth1; dt2 = dates.prevMonth2; break;
    }
    setDate1(dt1);
    setDate2(dt2);
    onOk(dt1, dt2);
  }
  // useEffect(() => {
  //   console.log({ date1, date2, dates, isThisWeek, isPrevWeek, isThisMonth, isPrevMonth });
  // }, [date1, date2]);
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showCustomDate,
    () => setShowCustomDate(false)
  );

  const onOk = (dt1: Date | null, dt2: Date | null) => {
    setShowCustomDate(false);
    onDateChange(dt1 ?? date1, dt2 ?? date2);
    // console.log({ date1, date2 });
  }


  const caption = isThisWeek ? "อาทิตย์นี้" : isPrevWeek ? "อาทิตย์ก่อน" : isThisMonth ? "เดือนนี้" : isPrevMonth ? "เดือนก่อน" : (date1 == null || date2 == null ? "อาทิตย์นี้" : (Utils.getDateRangeText(date1, date2)));


  return (
    <>
      <div className="tkd-status-summary-card wp-conver-content" style={{ position: "relative" }}>
        {taskDashStatusLoading && (<Loader />)}
        <h4 className="hand no-wrap overflow-hide" onClick={onClickHeader}><u>{caption}</u></h4>
        <LineDash />
        <div className="tkd-status-grid" >
          <div className={"d-flex justify-content-between hand hover badge-task-status-todo"} onClick={(e) => onFilterTaskTitle("NEW_TASK")}><span>📋งานเปิดใหม่</span><span>{taskStatusRange?.inRangeOpen}</span></div>
          <div className={"d-flex justify-content-between hand hover badge-task-status-finished"} onClick={(e) => onFilterTaskTitle("FINISHED_TASK")}><span>✅งานเสร็จ</span><span>{taskStatusRange?.inRangeFinished}</span></div>
        </div>
      </div>
      <div style={{ height: "10px" }}></div>
      <div className="tkd-status-summary-card wp-conver-content" style={{ position: "relative" }} >
        <div className={"d-flex justify-content-between hand hover badge-task-status-ongoing"} title="งานใกล้กำหนดในอีก 7 วัน" onClick={(e) => onFilterTaskTitle("COMING_DUE")}><span>⏳ใกล้กำหนด</span><span>{taskStatusRange?.cominigDue}</span></div>
        <div className={"d-flex justify-content-between hand hover badge-task-status-cancel"} title="งานเลยกำหนด" onClick={(e) => onFilterTaskTitle("OVERDUE")}><span>🚨 เลยกำหนด</span><span>{taskStatusRange?.overdue}</span></div>
      </div>

      {showCustomDate && (
        <div ref={popRef} className="wp-conver-content" style={{ zIndex: "9", width: "230px", position: "fixed", top: popCur.y, left: popCur.x - 50 }}>
          <div>
            <span onClick={(e) => setDateRange("THIS_WEEK")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isThisWeek })}>อาทิตย์นี้</span>
            <span onClick={(e) => setDateRange("PREV_WEEK")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isPrevWeek })}>อาทิตย์ก่อน</span>
            <span onClick={(e) => setDateRange("THIS_MONTH")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isThisMonth })}>เดือนนี้</span>
            <span onClick={(e) => setDateRange("PREV_MONTH")} className={classnames("wp-tag-filter hand hover fz-12", { "active-primary": isPrevMonth })}>เดือนก่อน</span>
          </div>
          <div>
            หรือ จาก
            <DatePickerEx isDisabled={false} onDateChanged={(e) => setDate1(e)} selectedDate={date1} />
            ถึง
            <DatePickerEx isDisabled={false} onDateChanged={(e) => setDate2(e)} selectedDate={date2} />
          </div>
          <div className="d-flex justify-content-end mt-2" style={{ gap: "6px" }}>
            <button className="btn btn-secondary" onClick={(e) => setShowCustomDate(false)}>ปิด</button>
            <button className="btn btn-primary" onClick={(e) => onOk(null, null)}>ตกลง</button>
          </div>
        </div>
      )}

    </>
  );
};

interface UserHeaderProps {
  user: UserStruct;
  myTaskSummary: any;
  allTaskSummary: any;
  onReloadTaskTitle(taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: number | null, requesterId: number | null): void;
  curUserId: number;
  curUserTagId: number;
  onDateChange(date1: Date | null, date2: Date | null): void;
  taskStatusRange: any;
  taskDashLoading: boolean;
  taskDashStatusLoading: boolean;
  onFilterTaskTitle(mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "OVERDUE"): void;
  onRefresh(): void;
  onFilterTagChange(tagID: number | null): void;
  filterTagId: number | null;
}

const UserHeader: React.FC<UserHeaderProps> = ({ user, myTaskSummary, allTaskSummary, onReloadTaskTitle, curUserId, curUserTagId, onDateChange, onRefresh, onFilterTagChange, taskStatusRange, taskDashLoading, taskDashStatusLoading, onFilterTaskTitle, filterTagId }) => {
  // console.log({ myTaskSummary, allTaskSummary });
  return (
    // <div className="tkd-user-header">
    //   {/* <div className="tkd-user-info">
    //     <UserAvatar profileImage={user.pictureUrl ?? "/avatar-default.png"} size="lg" />
    //   </div>

    //   <div className="tkd-summary-area">
    //     <StatusSummary title="MINE" data={myTaskSummary} />
    //     <StatusSummary title="ALL" data={allTaskSummary} />
    //   </div> */}
    //   <StatusSummary title="MINE" data={myTaskSummary} />
    //   <StatusSummary title="ALL" data={allTaskSummary} />
    // </div>
    <>
      <div className="row">
        <div className="col">
          <div className="d-flex justify-content-between">
            <h4>สรุปงานประจำปี
              <HelpInfo infos={[
                "Dashboard แสดงงานทั้งหมด ของพนักงานตามสายงาน/พนักงานที่ติดตาม/เป็นผู้มอบหมาย/ผู้ของาน"
                , "เป็นข้อมูลงานในปีปัจจุบัน"
              ]} />
            </h4>
            <h4>
              {taskDashLoading && (<LoadingIconWithText loadingText={""} />)}
              {!taskDashLoading && (<i className="fa fa-refresh hand" onClick={onRefresh}></i>)}
            </h4>
          </div>
        </div>
      </div>
      <TagListControl onFilterTagChange={onFilterTagChange} filterTagId={filterTagId} />
      <div className="row">
        <div className={classnames("col ", { "hide": fnGetTaskCount(myTaskSummary, filterTagId) <= 0 })}>
          <StatusSummary title="MINE" data={myTaskSummary} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} filterTagId={filterTagId} />
        </div>
        <div className={classnames("col ")}>
          <StatusSummary title="ALL" data={allTaskSummary} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} filterTagId={filterTagId} />
        </div>
        <div className="col ">
          <RangeStatusStat onDateChange={onDateChange} taskStatusRange={taskStatusRange} taskDashStatusLoading={taskDashStatusLoading} onFilterTaskTitle={onFilterTaskTitle} />
        </div>
      </div>
    </>
  );
};




const TAB_ALL = "a";
const TAB_ASS = "b";
const TAB_REQ = "c";
const TAB_DIV = "d";

interface TaskTableProps {
  data: any[];
  activeTab: string;
  onReloadTaskTitle(taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: number | null, requesterId: number | null): void;
  curUserId: number;
  curUserTagId: number;
  containerWidth: number;
}

const TaskTable: React.FC<TaskTableProps> = ({ data, activeTab, onReloadTaskTitle, curUserId, curUserTagId, containerWidth }) => {
  const isSmallScreen = containerWidth <= 768;
  const groupByDivision = activeTab === TAB_DIV;
  const divisions = (groupByDivision && data)
    ? Object.values(
      data.reduce((acc, item) => {
        const key = item.divisionName;

        if (!acc[key]) {
          acc[key] = {
            divisionName: key,
            status_ToDo: 0,
            status_Finished: 0,
            status_Cancel: 0,
            status_OnGoing: 0,
            status_Hold: 0,
            respondTagIds: [],
          };
        }

        acc[key].status_ToDo += item.status_ToDo ?? 0;
        acc[key].status_Finished += item.status_Finished ?? 0;
        acc[key].status_Cancel += item.status_Cancel ?? 0;
        acc[key].status_OnGoing += item.status_OnGoing ?? 0;
        acc[key].status_Hold += item.status_Hold ?? 0;
        acc[key].respondTagIds.push(item.respondTagId);

        return acc;
      }, {} as Record<string, any>)
    ).sort((a: any, b: any) => a.divisionName.localeCompare(b.divisionName))
    : [{}];

  // console.log('divisions:', divisions);

  const [memDivCollapse, setMemDivCollapse] = useState<string[]>((localStorage.getItem("dshdiv") ?? "").split('|'));
  useEffect(() => { localStorage.setItem("dshdiv", memDivCollapse.join("|")); }, [memDivCollapse])
  const toggleDiv = (divName: string) => {
    // setMemDivCollapse(prev => {
    //   if (prev.includes(divName)) {
    //     return prev.filter(x => x !== divName);
    //   } else {
    //     return [divName, ...prev];
    //   }
    // });
    // bellow is one div open in a time
    setMemDivCollapse(prev => {
      if (prev.includes(divName)) {
        return [];
      } else {
        return [divName];
      }
    });

  };

  return (
    <AppSimpleBar className="wp-conver-content" style={{ maxHeight: "calc(100vh - 380px)" }}>
      <table className="tkd-task-table w-100">
        <thead>
          <tr>
            <th align="left">เจ้าของงาน</th>
            {taskStatuses.map((x: TaskStatus) => (
              <th key={'h' + x} align="center">{Utils.GetTaskStatusIcon(x)}{isSmallScreen ? "" : Utils.GetTaskStatusText(x)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {divisions.map((div: any, idxDiv: number) => {
            const emp = groupByDivision ? (data ?? []).filter(x => x.divisionName == div.divisionName) : (data ?? []);
            const divCollapse = groupByDivision ? memDivCollapse.includes(div.divisionName) : true;
            const divKey = groupByDivision ? div.divisionName : "";
            return (
              <Fragment key={idxDiv}>
                {div.divisionName && (
                  <tr key={divKey + idxDiv} className="text-primary">
                    <td className="hand hover" onClick={(e) => toggleDiv(div.divisionName)}><i className={"fas fa-angle-double-" + (divCollapse ? "up" : "down") + " me-1"}></i>{div.divisionName}</td>
                    {taskStatuses.map((x: TaskStatus) => {
                      const field = "status_" + TaskStatus[x];
                      const count = div[field] ?? 0;
                      return (
                        <td
                          key={divKey + x}
                          align="center" className={classnames({ "hand hover": count > 0 })}
                          onClick={(e) => count > 0 ? onReloadTaskTitle(x, div.divisionName, div.respondTagIds, null, null) : null}
                        >
                          {count > 0 ? count : ""}
                        </td>
                      )
                    })}
                  </tr>
                )}
                {divCollapse && emp.map((row, idx) => {
                  const assignerId = (activeTab == TAB_ASS ? curUserId : null) ?? null;
                  const requesterId = (activeTab == TAB_REQ ? curUserId : null) ?? null;
                  return (
                    <tr key={divKey + idx}>
                      <td className={"hand hover" + (groupByDivision ? " ps-3" : "")} onClick={(e) => onReloadTaskTitle(null, row.respondId, [row.respondTagId], assignerId, requesterId)}>{row.displayName}
                        <UserAvatarWithName keyValue={idx} abbrName={row.abbrName} backColor={row.bgColor} displayName2={row.displayName2} foreColor={row.foreColor} profileImage={row.profileImage} userId={row.respondId} />
                      </td>
                      {taskStatuses.map((x: TaskStatus) => {
                        const field = "status_" + TaskStatus[x];
                        const count = row[field] ?? 0;
                        return (
                          <td
                            key={divKey + idx + '.' + x}
                            align="center" className={classnames({ "hand hover": count > 0 })}
                            onClick={(e) => count > 0 ? onReloadTaskTitle(x, row.respondId, [row.respondTagId], assignerId, requesterId) : null}
                          >
                            {count > 0 ? count : ""}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </AppSimpleBar>
  );
};




interface TaskTabsProps {
  allTasks: any[];
  assignerTasks: any[];
  requesterTasks: any[];
  curUserId: number;
  curUserTagId: number;
  containerWidth: number;
  onReloadTaskTitle(taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: number | null, requesterId: number | null): void;
}

const TaskTabs: React.FC<TaskTabsProps> = ({ allTasks, assignerTasks, requesterTasks, onReloadTaskTitle, curUserId, curUserTagId, containerWidth }) => {
  const [activeTab, setActiveTab] = useState<string>(localStorage.getItem("tkdtab") ?? TAB_ALL);

  const getData = () => {
    switch (activeTab) {
      case TAB_ASS:
        return assignerTasks;
      case TAB_REQ:
        return requesterTasks;
      case TAB_DIV:
        return allTasks;
      default:
        return allTasks;
    }
  };
  useEffect(() => {
    localStorage.setItem("tkdtab", activeTab);
  }, [activeTab]);

  const a1 = activeTab == TAB_ALL ? "" : "outline-";
  const a2 = activeTab == TAB_ASS ? "" : "outline-";
  const a3 = activeTab == TAB_REQ ? "" : "outline-";
  const a4 = activeTab == TAB_DIV ? "" : "outline-";

  return (
    <div className="tkd-task-tabs">
      <div className="tkd-tab-header mb-1" >
        <button className={classnames("btn btn-sm fz-10 btn-" + a1 + "secondary hand hover")} onClick={() => setActiveTab(TAB_ALL)}>งานทั้งหมด</button>
        <button className={classnames("btn btn-sm fz-10 btn-" + a2 + "secondary hand hover")} onClick={() => setActiveTab(TAB_ASS)}>งานที่มอบหมาย</button>
        <button className={classnames("btn btn-sm fz-10 btn-" + a3 + "secondary hand hover")} onClick={() => setActiveTab(TAB_REQ)}>งานที่ขอ</button>
        <button className={classnames("btn btn-sm fz-10 btn-" + a4 + "secondary hand hover")} onClick={() => setActiveTab(TAB_DIV)}>ตามหน่วยงาน</button>
      </div>
      {/* <LineDash /> */}
      <TaskTable key={activeTab} data={getData()} activeTab={activeTab} onReloadTaskTitle={onReloadTaskTitle} curUserId={curUserId} curUserTagId={curUserTagId} containerWidth={containerWidth} />
    </div>
  );
};

interface SelectTagFilterProps {
  selectedTagId: any;
  tagList: any[];
  onSelectedTagChanged(tagId: any): void;
}
const SelectTagFilter = ({ tagList, selectedTagId, onSelectedTagChanged }: SelectTagFilterProps) => {
  const tagListForSel = tagList.map(x => ({ ...x, label: x.tagName, value: x.tagId }));
  // console.log('tagList:', tagListForSel);

  const Option = ({ data, isOption }: { data: any, isOption: boolean }) => {
    return (
      <div className="xyz12 d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
        <span className={isOption ? "ps-2" : ""}>{data.label}</span>
        <span className={isOption ? "pe-2" : ""}>{data.taskCount}</span>
      </div>
    );
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (<components.Option {...props}><Option data={data} isOption={true} /></components.Option>);
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;
    return (<components.SingleValue {...props}><Option data={data} isOption={false} /></components.SingleValue>);
  };
  const onValueChanged = (tagId: any) => {
    onSelectedTagChanged(tagId);
  }
  return (
    <SelectDropdown
      isDisabled={false}
      list={tagListForSel}
      onValueChanged={onValueChanged}
      selectedValue={tagListForSel.find(e => e.tagId == selectedTagId) ?? null}
      customOption={CustomOption}
      customValue={CustomSingleValue}
      placeholder={"เลือก tag ที่ต้องการดู"}
      isMulti={false}
    />
  );
}

interface TagListControlProps {
  filterTagId: number | null;
  onFilterTagChange(tagId: number | null): void
}
const TagListControl: React.FC<TagListControlProps> = ({ onFilterTagChange, filterTagId }) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      taskDashTags: wp.taskDashTags,
      taskDashTagsLoading: wp.taskDashTagsLoading
    })
  );
  const { taskDashTags, taskDashTagsLoading } = useAppSelector(storeData);

  const onFilterTagChangeIn = (tagID: any) => {
    if (tagID) {
      onFilterTagChange(Utils.ToNumber(tagID, null));
    } else {
      onFilterTagChange(null);
    }
  }

  return (
    <div style={{ position: "relative" }} className="">
      {/* <select className="form-control w-auto mb-2" style={{ minWidth: "200px" }} value={filterTagId == null ? "" : filterTagId.toString()} onChange={(e) => onFilterTagChangeIn(e.target.value)}>
        <option>เลือก tag ที่ต้องการดู</option>
        {taskDashTags.map((item: any, idx: number) => (
          <option key={idx} value={item.tagId}>{item.tagName} ({item.taskCount})</option>
        ))}
      </select> */}
      <div style={{ width: "30%", minWidth: "350px", marginBottom: "8px" }}>
        <SelectTagFilter onSelectedTagChanged={onFilterTagChangeIn} selectedTagId={filterTagId} tagList={taskDashTags} />
      </div>
      {taskDashTagsLoading && (
        <div style={{ position: "absolute", left: "0", top: "8px" }}>
          <LoadingIconWithText loadingText={""} />
        </div>
      )}
    </div>
    // <div>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>
    //   <span className="wp-tag-filter-2 hand mb-2 hover" data-tg="79703.AAA">AAA (2)</span>            

    // </div>
  );
}

const WelcomeTask2 = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.WpSlice,
    (p2: UserStruct, wp: WpSliceData) => ({
      curUser: p2,
      taskAll: wp.taskDash?.taskAll,
      taskResponder: wp.taskDash?.taskResponder,
      taskAssigner: wp.taskDash?.taskAssigner,
      taskRequester: wp.taskDash?.taskRequester,
      taskStatusRange: wp.taskDash?.taskStatusRange,
      taskDashStatusLoading: wp.taskDashStatusLoading ?? false,
      taskDashLoading: wp.taskDashLoading ?? false,
      taskStatusesEx: wp.titlesTk.map(x => `${x.taskStatus}`).join("|"),
      taskDashFilterTagId: wp.taskDashFilterTagId,
      // taskStatusesx: wp.titlesTk.map(x => `${x.taskStatus}`).join("|"),
    })
  );
  const { curUser, taskAll, taskResponder, taskAssigner, taskRequester, taskStatusesEx, taskStatusRange, taskDashStatusLoading, taskDashLoading, taskDashFilterTagId } = useAppSelector(storeData);

  const [date1, setDate1] = useState<Date | null>(Utils.GetFirstDateOfWeek(null));
  const [date2, setDate2] = useState<Date | null>(Utils.GetLastDateOfWeek(null));
  // const [filterTagId, setFilterTagId] = useState<number | null>(StorageUtils.DashboardFilterTagId);

  // useEffect(() => {
  //   console.log('filterTagId:', filterTagId);
  // }, [filterTagId]);

  const onDateChange = (dateParm1: Date, dateParm2: Date) => {
    setDate1(dateParm1);
    setDate2(dateParm2);
    // console.log(dateParm1.toLocaleDateString(), dateParm2.toLocaleDateString());
    dispatch(loadTaskDashStatusRange(dateParm1, dateParm2, taskDashFilterTagId));
  }


  useEffect(() => {
    // console.log('statusKey:', statusKey);
    dispatch(loadTaskDash(date1, date2, taskDashFilterTagId));
  }, [taskStatusesEx]);

  useEffect(() => {
    // console.log('WelcomeTask2:Render');
    dispatch(loadTaskDash(date1, date2, taskDashFilterTagId));
    dispatch(loadTaskDashTags());
  }, []);

  const taskStatusAll = {
    status_ToDo: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_ToDo }, 0),
    status_Finished: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Finished }, 0),
    status_Cancel: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Cancel }, 0),
    status_OnGoing: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_OnGoing }, 0),
    status_Hold: taskAll?.reduce((acc: any, cur: any) => { return acc + cur.status_Hold }, 0),
  }

  const fnLoadTaskTitle = async (taskStatus: TaskStatus | null, respondId: string | null | undefined, respondTagId: number[] | null, assignerId: number | null, requesterId: number | null) => {
    const memberRole = Utils.GetMemberRoleFromStorage(WpModes.Task);
    const filterStaus = taskStatus ? [taskStatus] : [];
    // console.log('fnLoadTaskTitle:', { taskStatus, respondId });
    const tags = respondTagId != null ? respondTagId : taskAll?.map((x: any) => x.respondTagId);
    const tag2 = taskDashFilterTagId == null ? [] : [taskDashFilterTagId];
    // console.log('tags:', tags);
    dispatch(loadPostTitle(
      WpModes.Task, "", [], memberRole, tag2/*tags*/, false, false, WpEmpFilterType.TaskOwner, null, "dash", filterStaus, true, respondId, assignerId, requesterId
    ));
  }

  const onFilterTaskTitle = async (mode: "NEW_TASK" | "FINISHED_TASK" | "COMING_DUE" | "OVERDUE") => {
    const taskStatus = mode == "NEW_TASK" ? TaskStatus.ToDo : TaskStatus.Finished;
    const memberRole = Utils.GetMemberRoleFromStorage(WpModes.Task);
    const filterStaus = taskStatus ? [taskStatus] : [];
    // console.log('fnLoadTaskTitle:', { taskStatus, respondId });
    const tags = taskAll?.map((x: any) => x.respondTagId);
    const tags2 = taskDashFilterTagId == null ? [] : [taskDashFilterTagId];

    dispatch(loadPostTitle(
      WpModes.Task, mode, [], memberRole, tags2 /*tags*/, false, false, WpEmpFilterType.TaskOwner, null, "dash", filterStaus, true, null, null, null, date1, date2
    ));

  }

  // type DATE_RANGES = "THIS_WEEK" | "PREV_WEEK" | "THIS_MONTH" | "PREV_MONTH";
  // const [selDateRange, setSelDateRange] = useState<DATE_RANGES>("THIS_WEEK");
  const { ref, width: containerWidth } = ElementWidthObserver<HTMLDivElement>();
  const onRefresh = async () => {
    dispatch(loadTaskDash(date1, date2, null));
    dispatch(loadTaskDashTags());
  }

  const onFilterTagIdChange = (tagID: number | null) => {
    // console.log('onFilterTagIdChange:', tagID);
    dispatch(setTaskDashFilterTagId(tagID));
    StorageUtils.DashboardFilterTagId = tagID;
    dispatch(loadTaskDash(date1, date2, tagID));
  }

  return (
    <React.Fragment>
      <div ref={ref} className="chat-welcome-section " style={{ alignItems: "flex-start", justifyContent: "flex-start", width: "100%" }} >
        <div className="tkd-dashboard-container  w-100" >
          <UserHeader
            user={curUser}
            myTaskSummary={taskResponder}
            allTaskSummary={taskStatusAll}
            onReloadTaskTitle={fnLoadTaskTitle}
            curUserId={curUser.userId ?? -1}
            curUserTagId={curUser.userId ?? -1}
            onDateChange={onDateChange}
            taskStatusRange={taskStatusRange}
            taskDashStatusLoading={taskDashStatusLoading}
            onFilterTaskTitle={onFilterTaskTitle}
            onRefresh={onRefresh}
            taskDashLoading={taskDashLoading}
            onFilterTagChange={onFilterTagIdChange}
            filterTagId={taskDashFilterTagId}
          />
          <LineDash />
          <TaskTabs
            allTasks={taskAll}
            assignerTasks={taskAssigner}
            requesterTasks={taskRequester}
            onReloadTaskTitle={fnLoadTaskTitle}
            curUserId={curUser.userId ?? -1}
            curUserTagId={curUser.userId ?? -1}
            containerWidth={containerWidth}
          />
        </div>
      </div>

    </React.Fragment>
  );
};

export default WelcomeTask2;
